var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleOutlineBlack24Dp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1764_7095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.66675C6.48 1.66675 2 5.40008 2 10.0001C2 14.6001 6.48 18.3334 12 18.3334C17.52 18.3334 22 14.6001 22 10.0001C22 5.40008 17.52 1.66675 12 1.66675ZM12 16.6667C7.59 16.6667 4 13.6751 4 10.0001C4 6.32508 7.59 3.33341 12 3.33341C16.41 3.33341 20 6.32508 20 10.0001C20 13.6751 16.41 16.6667 12 16.6667ZM15.88 6.90841L10 11.8084L8.12 10.2417C7.73 9.91675 7.1 9.91675 6.71 10.2417C6.32 10.5667 6.32 11.0917 6.71 11.4167L9.3 13.5751C9.69 13.9001 10.32 13.9001 10.71 13.5751L17.3 8.08341C17.69 7.75841 17.69 7.23341 17.3 6.90841C16.91 6.58341 16.27 6.58341 15.88 6.90841Z",
    fill: "#077CA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1764_7095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutlineBlack24Dp);
export default __webpack_public_path__ + "static/media/check_circle_outline_black_24dp.d88edbd7b30af343f4fe153f2d10cac8.svg";
export { ForwardRef as ReactComponent };